import { Box, ListItem } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import Iconify from "minimals-template/components/Iconify"

export function NewItem({ task }) {
    const index = task.$sort ? `${task.$sort + 1}. ` : ""
    return (
        <ListItem data-cy="new-item">
            <ListItemBox>
                <Box flex={1}>
                    {index}
                    {task.title}
                </Box>
                <Box width={80}>
                    <Box ml={-0.5}>
                        <Iconify icon="mdi:star" />
                    </Box>
                </Box>
            </ListItemBox>
        </ListItem>
    )
}
